<template>
  <v-dialog v-model="dialog" max-width="500px">
    <v-card>
      <v-card-title>
        <span class="s1">Payment Receipt</span>
      </v-card-title>
      <v-card-text>
        <v-form ref="form" v-model="valid">
          <v-text-field
            v-model="paymentAmount"
            label="Payment Amount"
            type="number"
            :rules="[v => !!v || 'Payment amount is required']"
            required
          />
          <v-select
            v-model="paymentMethod"
            :items="paymentMethods"
            label="Payment Method"
            :rules="[v => !!v || 'Payment method is required']"
            required
          />
          <v-text-field
            v-model="referenceId"
            label="Reference ID (Optional)"
          />
          <v-file-input
            v-model="proofOfPayment"
            label="Proof of Payment"
            accept="image/jpeg, application/pdf"
            :rules="[v => !!v || 'Proof of payment is required']"
            required
          />
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
        <v-btn
          class="textColorAccent white--text"
          @click="submit"
          :disabled="!valid || isSubmitting"
          :loading="isSubmitting"
        >
          Submit
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog v-model="confirmationDialog" persistent max-width="400">
      <v-card>
        <v-card-text class="text-center pa-5">
          <v-progress-circular
            v-if="isSubmitting"
            indeterminate
            color="primary"
            size="64"
          ></v-progress-circular>
          <v-icon
            v-else
            color="green"
            size="64"
          >
            mdi-check-circle
          </v-icon>
          <p class="mt-4" v-html="confirmationMessage"></p>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import axios from 'axios';

export default {
  props: {
    invoicePid: {
      type: String,
      required: true
    },
    redirectUrl: {
      type: String,
      required: true
    }
  },
  data: () => ({
    dialog: false,
    confirmationDialog: false,
    valid: false,
    isSubmitting: false,
    confirmationMessage: '',
    paymentAmount: null,
    paymentMethod: null,
    referenceId: '',
    proofOfPayment: null,
    paymentMethods: [
      { text: 'Cash', value: 'cash' },
      { text: 'Bank Transfer', value: 'bank_transfer' },
      { text: 'ATM Transfer', value: 'atm_transfer' }
    ]
  }),
  methods: {
    open() {
      this.dialog = true;
    },
    close() {
      this.dialog = false;
      this.$refs.form.reset();
    },
    async getLeadId() {
      try {
        const response = await axios.get(`https://yezza-api.arbatravel.com/leads/${this.invoicePid}`);
        return response.data.id;
      } catch (error) {
        console.error('Error fetching lead ID:', error);
        throw error;
      }
    },
    async createTransaction(leadId) {
      const transactionData = {
        amount: this.paymentAmount * 100,
        gateway: "direct",
        lead: leadId,
        ref_id: this.referenceId || null,
        payment_method: this.paymentMethod,
        internal_description: null
      };

      try {
        const response = await axios.post('https://yezza-api.arbatravel.com/transactions', transactionData);
        return response.data.uid;
      } catch (error) {
        console.error('Error creating transaction:', error);
        throw error;
      }
    },
    async uploadFile(uid) {
      const formData = new FormData();
      formData.append('file', this.proofOfPayment);

      try {
        await axios.patch(`https://yezza-api.arbatravel.com/transactions/${uid}`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });
      } catch (error) {
        console.error('Error uploading file:', error);
        throw error;
      }
    },
    async submit() {
      if (this.$refs.form.validate()) {
        this.isSubmitting = true;
        this.confirmationDialog = true;
        this.confirmationMessage = 'Submitting payment...';

        try {
          const leadId = await this.getLeadId();
          const transactionUid = await this.createTransaction(leadId);
          await this.uploadFile(transactionUid);

          this.isSubmitting = false;
          this.confirmationMessage = 'Your proof of payment has been sent.<br>Once confirmed by the ARBA Travel Finance team, it will reflect in the invoice payment list.';
          
          setTimeout(() => {
            this.$emit('payment-submitted', transactionUid);
            this.close();
            this.confirmationDialog = false;
            window.location.href = `https://invoice.arbatravel.com/invoices/${this.invoicePid}`;
          }, 5000); // Increased to 5 seconds to allow reading the message
        } catch (error) {
          console.error('Error in submission process:', error);
          this.isSubmitting = false;
          this.confirmationMessage = 'An error occurred. Please try again.';
          // You might want to add a button to close the confirmation dialog or retry
        }
      }
    }
  }
}
</script>